module.exports = __webpack_public_path__ + "img/tp.c7412715.png";